/**
 * @author    Labs64 <netlicensing@labs64.com>
 * @license   Apache-2.0
 * @link      https://netlicensing.io
 * @copyright 2017 Labs64 NetLicensing
 */
const TransactionSource = Object.freeze({
  SHOP: 'SHOP',

  AUTO_LICENSE_CREATE: 'AUTO_LICENSE_CREATE',
  AUTO_LICENSE_UPDATE: 'AUTO_LICENSE_UPDATE',
  AUTO_LICENSE_DELETE: 'AUTO_LICENSE_DELETE',

  AUTO_LICENSEE_CREATE: 'AUTO_LICENSEE_CREATE',
  AUTO_LICENSEE_DELETE: 'AUTO_LICENSEE_DELETE',
  AUTO_LICENSEE_VALIDATE: 'AUTO_LICENSEE_VALIDATE',

  AUTO_LICENSETEMPLATE_DELETE: 'AUTO_LICENSETEMPLATE_DELETE',

  AUTO_PRODUCTMODULE_DELETE: 'AUTO_PRODUCTMODULE_DELETE',

  AUTO_PRODUCT_DELETE: 'AUTO_PRODUCT_DELETE',

  AUTO_LICENSES_TRANSFER: 'AUTO_LICENSES_TRANSFER',

  SUBSCRIPTION_UPDATE: 'SUBSCRIPTION_UPDATE',

  RECURRING_PAYMENT: 'RECURRING_PAYMENT',

  CANCEL_RECURRING_PAYMENT: 'CANCEL_RECURRING_PAYMENT',

  OBTAIN_BUNDLE: 'OBTAIN_BUNDLE',
});

export default TransactionSource;
